import HttpMethodType from 'HttpMethodType';
import SubSystemType from 'SubSystemType';
import BaseServiceRequest from 'BaseServiceRequest';

class GetFundHoldingsDataRequest extends BaseServiceRequest {
    constructor(fundticker) {
        super();
        super.addRequestUri("fundholdings.pb");
        super.addRequestParameter("fundticker", fundticker);
    }

    getMethod() {
        return HttpMethodType.GET;
    }

    getSubSystem() {
        return SubSystemType.GRAPH;
    }

    getMessageName() {
        return "FundHoldingsResponse";
    }
}

export default GetFundHoldingsDataRequest;
